import {MutationTree} from 'vuex';
import {HaciendaState, HaciendaItem} from './types'
type HaciendasMutationTree = MutationTree<HaciendaState>;
export const mutations: HaciendasMutationTree={
    setHaciendas(state: HaciendaState, payload: Array<HaciendaItem>){
        state.haciendas=payload;
    }
};